import { types } from 'mobx-state-tree';
import formatter from './CurrencyFormatter';

export const SalespersonExpense = types.model('SalespersonExpense', {
    salary: types.maybe(types.number),
    commissions: types.maybe(types.number),
    expenses: types.maybe(types.number),
    attributedExpenses: types.maybe(types.number)
})
    .views(self => ({
        // Untouched fields are undefined (types.maybe) — coerce to 0 so one
        // blank input doesn't NaN-blank Total Earnings / Expenses / ROI /
        // Multiply Metric across the whole Value Report (and "$NaN" in the
        // emailed version).
        get totalEarningsNumber() {
            return (self.salary || 0) + (self.commissions || 0);
        },
        get totalEarnings() {
            return isNaN(self.totalEarningsNumber) ? '' : formatter.format(self.totalEarningsNumber);
        },
        get expensesPaidNumber() {
            return (self.expenses || 0) - (self.attributedExpenses || 0);
        },
        get expensesPaid() {
            return isNaN(self.expensesPaidNumber) ? '' : formatter.format(self.expensesPaidNumber);
        }
    }));

export const NullSalespersonExpense = SalespersonExpense.create(
    {
        salary: 0,
        commissions: 0,
        expenses: 0,
        attributedExpenses: 0
    }
);